// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2999":"css/fontawesome","4955":"css/page-guides","6663":"css/core","9460":"css/dropzone","9613":"css/transcript-sync"}[chunkId] + ".css";
};